"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _react = _interopRequireDefault(require("react")),
    _AssetPreview = _interopRequireDefault(require("../components/AssetPreview")),
    _Uploader = require("../../Uploader"),
    AssetWrappedPreview = (0, _Uploader.withAssetSelector)(_AssetPreview["default"]);

function AssetPreview(props) {
  var assetId = props.assetId,
      asset = props.asset,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["assetId", "asset"]);
  return assetId ? _react["default"].createElement(AssetWrappedPreview, (0, _extends2["default"])({
    assetId: assetId
  }, otherProps)) : _react["default"].createElement(_AssetPreview["default"], (0, _extends2["default"])({
    asset: asset
  }, otherProps));
}

var _default = AssetPreview;
exports["default"] = _default;